/*
 * Global media skeleton — reveals `.media-skeleton` media once its image loads.
 * Pairs with the .media-skeleton CSS in base.css.
 *
 * Behaviour (per the UX loading guidance):
 *  - Cached / already-complete images are left visible → no shimmer flash.
 *  - Not-yet-loaded images get `.is-loading` (shimmer + hidden img) + aria-busy,
 *    revealed with a fade on `load` (also cleared on `error`, so a broken image
 *    never leaves the shimmer stuck).
 *  - A MutationObserver picks up cards/media injected via AJAX (collection grid,
 *    quick-add, wishlist, search) with no per-surface wiring.
 *  - Fail-safe: this script ADDS the hidden state; if it never runs, images show.
 */
(function () {
  var BOUND = 'skelBound';

  function watch(container) {
    if (!container || container.dataset[BOUND] === '1') return;
    container.dataset[BOUND] = '1';

    var img = container.querySelector('img');
    // No image, or already loaded from cache → nothing to skeleton.
    if (!img || (img.complete && img.naturalWidth > 0)) return;

    container.classList.add('is-loading');
    container.setAttribute('aria-busy', 'true');

    function done() {
      container.classList.remove('is-loading');
      container.removeAttribute('aria-busy');
      img.removeEventListener('load', done);
      img.removeEventListener('error', done);
    }
    img.addEventListener('load', done);
    img.addEventListener('error', done);
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('.media-skeleton').forEach(watch);
    // If the injected root IS a media-skeleton, handle it too.
    if (root && root.classList && root.classList.contains('media-skeleton')) watch(root);
  }

  function start() {
    init(document);

    // Auto-watch AJAX-injected content.
    if ('MutationObserver' in window) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType === 1) init(n);
          }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Theme-editor + Section Rendering API reloads.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Exposed so a surface can trigger a manual scan if ever needed.
  window.initMediaSkeleton = init;
})();
